import React, { useState, useEffect, useContext, useRef } from 'react';
import {
    List, Datagrid, TextField, TextInput, Create, SimpleForm, Toolbar as RaToolbar, SaveButton, Edit, EditButton,
    SimpleList, Button as RaButton, useRecordContext, useRedirect, FunctionField, useRefresh
} from 'react-admin';
import {
    useMediaQuery, makeStyles, withStyles, Dialog, DialogContent,
    DialogActions, Button, FormControl, InputLabel, Select, MenuItem
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import RaAutocompleteInput from "./components/RaAutocompleteInput";
import RaCheckBoxInput from './components/RaCheckBoxInput';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import ScrollableTable from './components/ScrollableTable';
import Skeleton from '@material-ui/lab/Skeleton';
import { vehicleSvgs } from "./sharedData";
import config from './config.json';
import CustomSearch from './components/CustomSearch';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import { io } from 'socket.io-client'
import { ContextProvider } from './globalContextProvider';
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import CustomCreateButton from './components/CustomCreateButton';

const socket = io(`${config.HOST_NAME}`, { transports: ['websocket', 'polling', 'flashsocket'] })

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "PERMIT ORGANIZATION SECTION"

export const RfidOrganizationList = props => {
    const eventTracker = UseAnalyticsEvent()
    const { showOrganizationLiveFeed, setShowOrganizationLiveFeed } = useContext(ContextProvider);
    const classes = useStyles();
    const location = useLocation()
    const refresh = useRefresh()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const listDataRef = useRef();
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [allowCompanyUserCreate] = useState(sessionStorage.getItem("allow_company_user_create") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [highLightRecordIds, setHighLightRecordIds] = useState("")

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));



    let searchTypeState = ["Company"]
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Company");
    const filter = { name: search ? search : undefined, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const postRowStyle = (record, index) => {
        return {
            animation: record && record.id === highLightRecordIds ? "blinkingBackground 2s infinite" : ""
        };
    }

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidOrganization?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `Permit Company Data.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getPDF = () => {
        getExportFile("pdf");
    };

    React.useEffect(() => {
        eventTracker(CATEGORY, " ORGANIZATIONS LIST")
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (showOrganizationLiveFeed) {
            eventTracker(CATEGORY, "LIVE FEED ENABLE")
            socket.on('connnection', () => {
                console.log('connected to server');
            })
            socket.on(`ORGANIZATION_LIVE_FEED`, ({ organizationId }) => {
                refresh()
                setHighLightRecordIds(organizationId)
                setTimeout(() => {
                    setHighLightRecordIds("")
                }, 5000);
                // setVisibleSnackBar({ value: true, vehicle_number: vehicle_number, action: action })
            })

            socket.on('message', (message) => {
                console.log(message);
            })

            socket.on('disconnect', () => {
                console.log('Socket disconnecting');
            })
        }

    }, [showOrganizationLiveFeed])// eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            {!viewOnly &&
                <>
                    <LiveFeed dialogVisible={dialogVisible} setDialogVisible={setDialogVisible} showOrganizationLiveFeed={showOrganizationLiveFeed} setShowOrganizationLiveFeed={setShowOrganizationLiveFeed} refresh={refresh} />
                    <CustomCreateButton label="Create Company" basePath={props.basePath} resource={props.resource} />
                </>
            }
            <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="RFID Organization"
            bulkActionButtons={false}
            sort={{ field: "name", order: "ASC" }}
            exporter={false}
            filter={filter}
            empty={false}
            hasCreate={!viewOnly}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => null}
                    secondaryText={record => (<div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["name"] ? `Company Name: ${record["name"]}` : ""}</div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>
                        <VehicleCapacityField vehicleTypes={["2", "4"]} isSmallDevice={isSmallDevice} />
                        {!viewOnly && <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            {allowCompanyUserCreate && <CustomCreateUserButton {...props} record={record} source="username" />}
                            {<EditButton {...props} record={record} />}
                            {<CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/rfidOrganization'} />}
                        </div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={!viewOnly ? 'rfidOrgDataGrid' : ''} component={ScrollableTable} rowStyle={postRowStyle}>
                    <TextField source="name" label="Company Name" />
                    <TextField source="parking_name" label="Parking Name" />
                    <VehicleCapacityField label="Vehicle Occupancy" vehicleTypes={["2", "4"]} />
                    {!viewOnly && allowCompanyUserCreate && <CustomCreateUserButton source="username" />}
                    {/* {!viewOnly && <EditButton />}
                    {!viewOnly && <DeleteButton mutationMode="pessimistic" />} */}
                    {!viewOnly && <FunctionField className="ListIconsContainerRfidOrg" render={record => record &&
                        <div className="ListIcons">
                            <div>
                                <EditButton {...props} title="Edit" label={false} record={record} />
                            </div>
                            <div>
                                <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/rfidOrganization'} />
                            </div>

                        </div>
                    } />}
                </Datagrid>
            }
        </List>
    </div>
};

const VehicleCapacityField = (props) => {
    const { vehicleTypes, isSmallDevice } = props;
    const record = useRecordContext(props);
    //const notify = useNotify();

    const [loading, setLoading] = useState(true);
    const [occupancyData, setOccupancyData] = useState({});

    useEffect(() => {
        fetch(`${config.HOST_NAME}/crm/v3/rfidOrganization/${record.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    setOccupancyData(json.data.occupancy);
                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((error) => {
                setLoading(false);
                notify('Error fetching occupany data', 'warning');
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (vehicleTypes.map(vehicleType => (
        <div style={{ marginRight: 7, marginTop: isSmallDevice ? 5 : 0, padding: "4px 10px", border: "1px solid #aaa", borderRadius: 1000, display: "inline-flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
            <img className="summaryVehicleIcon" src={vehicleSvgs[vehicleType]} alt={`Vehicle Type ${vehicleType}`} />
            <div style={{ marginLeft: 7, fontSize: 14 }}>
                {loading ?
                    <Skeleton variant="text" height={18} width={20} style={{ display: "inline-block", transform: "none" }} />
                    :
                    occupancyData[vehicleType]
                }
                /{record[`vehicle_type_${vehicleType}_capacity`]}
            </div>
        </div>
    )));
};
const validateUserCreation = (values) => {
    const errors = {};
    if (values.name == null || values.name === "") {
        errors.name = 'Company Name is Required';
    } else if (values.name.length > 200) {
        errors.name = 'Company Name is too long';
    }

    if (values.vehicle_type_2_capacity == null || values.vehicle_type_2_capacity === "") {
        errors.vehicle_type_2_capacity = 'Bike Capacity is Required';
    } else if (typeof values.vehicle_type_2_capacity === "string" && values.vehicle_type_2_capacity.search(/^\d+$/g) === -1) {
        errors.vehicle_type_2_capacity = 'Invalid Bike Capacity';
    }

    if (values.vehicle_type_4_capacity == null || values.vehicle_type_4_capacity === "") {
        errors.vehicle_type_4_capacity = 'Car Capacity is Required';
    } else if (typeof values.vehicle_type_4_capacity === "string" && values.vehicle_type_4_capacity.search(/^\d+$/g) === -1) {
        errors.vehicle_type_4_capacity = 'Invalid Car Capacity';
    }

    if (values.access_key_id == null || values.access_key_id === "") {
        errors.access_key_id = 'Please select a parking';
    }

    if (values.mobile_number != null && values.mobile_number !== "" && values.mobile_number.search(/^\d{10}$/g) === -1) {
        errors.mobile_number = 'Invalid Mobile Number';
    }

    return errors;
};
export const RfidOrganizationCreate = ({ permissions, ...props }) => {
    const [allowCompanyUserCreate] = useState(sessionStorage.getItem("allow_company_user_create") === "1");
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess} title="Create RFID Organization">
            <SimpleForm validate={validateUserCreation} redirect="list">
                <div style={{ display: "flex", width: "100%", gap: 25 }}>
                    <TextInput source="name" label="Company Name" variant="outlined" />
                    {allowCompanyUserCreate && <RaCheckBoxInput source="create_user" label="Create User" style={{ position: "relative", top: -10 }} />}
                </div>
                <div style={{ display: "flex", width: "100%", gap: 25 }}>
                    <TextInput source="vehicle_type_2_capacity" label="Total Bike Capacity" variant="outlined" />
                    <TextInput source="vehicle_type_4_capacity" label="Total Car Capacity" variant="outlined" />
                </div>
                <div style={{ display: "flex", width: "100%", gap: 25 }}>
                    <TextInput source="owner_name" label="Owner Name" variant="outlined" />
                    <TextInput source="mobile_number" label="Mobile Number" variant="outlined" />
                </div>
                <RaAutocompleteInput source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="Parking" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ minWidth: 340, maxWidth: 500, marginTop: 10, marginBottom: 30 }} />
            </SimpleForm>
        </Create>
    )
};

const validateEdit = values => {
    const errors = {};
    if (values.name == null || values.name === "") {
        errors.name = 'Company Name is Required';
    } else if (values.name.length > 200) {
        errors.name = 'Company Name is too long';
    }

    if (values.vehicle_type_2_capacity == null || values.vehicle_type_2_capacity === "") {
        errors.vehicle_type_2_capacity = 'Bike Capacity is Required';
    } else if (typeof values.vehicle_type_2_capacity === "string" && values.vehicle_type_2_capacity.search(/^\d+$/g) === -1) {
        errors.vehicle_type_2_capacity = 'Invalid Bike Capacity';
    }

    if (values.vehicle_type_4_capacity == null || values.vehicle_type_4_capacity === "") {
        errors.vehicle_type_4_capacity = 'Car Capacity is Required';
    } else if (typeof values.vehicle_type_4_capacity === "string" && values.vehicle_type_4_capacity.search(/^\d+$/g) === -1) {
        errors.vehicle_type_4_capacity = 'Invalid Car Capacity';
    }
    return errors;
};

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};
const CustomToolbar = withStyles(toolbarStyles)(props => (
    <RaToolbar {...props}>
        <SaveButton />
    </RaToolbar>
));

export const RfidOrganizationEdit = (props) => {
    const classes = useStyles();
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Edit {...props} undoable={false} onFailure={onFailure} onSuccess={onSuccess} classes={{ noActions: classes.editNoActions }}>
            <SimpleForm redirect="list" toolbar={<CustomToolbar />} style={{ padding: "0 12px" }} validate={validateEdit} >
                <TextInput source="name" label="Company Name" variant="outlined" />
                <div style={{ display: "flex", width: "100%", gap: 25 }}>
                    <TextInput source="vehicle_type_2_capacity" label="Total Bike Capacity" variant="outlined" />
                    <TextInput source="vehicle_type_4_capacity" label="Total Car Capacity" variant="outlined" />
                </div>
            </SimpleForm>
        </Edit>
    );
}

function CreateUserButton(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, resource, basePath } = props;
        const data = {
            ...record,
            create_user: 1
        };
        dispatchCrudUpdate(resource, record.id, data, record, basePath, "/rfidOrganization");
    };

    return (
        <div style={{ display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {record[source] ?
                record[source]
                :
                <RaButton disabled={props.disabled} label="Create User" color="secondary" onClick={openDialog}><PersonAddIcon /></RaButton>
            }

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to create a user for this company?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

CreateUserButton.defaultProps = {
    redirect: 'list',
    undoable: false
};

const CustomCreateUserButton = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(CreateUserButton);

const LiveFeed = ({ dialogVisible, setDialogVisible, showOrganizationLiveFeed, setShowOrganizationLiveFeed, refresh }) => {
    const classes = useStyles()

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    return (
        <div>
            <Button
                variant='contained'
                color="secondary"
                disableElevation
                size="small"
                style={{ textTransform: "none", fontWeight: 500, color: showOrganizationLiveFeed ? "#18cc69" : '#334d6e', fontSize: 14, fontFamily: "Poppins-Regular", padding: "13px 20px", letterSpacing: "0.06em", borderRadius: 10, backgroundColor: "#F5F8FA" }}
                onClick={openDialog}
            >
                <LiveTvIcon style={{ fontSize: 20 }} />
            </Button>
            <Dialog open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
                <DialogContent>
                    {showOrganizationLiveFeed ?
                        <p style={{ fontSize: 14 }}>Are you sure you want to <strong>Disable</strong> Live Feed</p>
                        :
                        <p style={{ fontSize: 14 }}>Are you sure you want to <strong>Enable</strong> Live Feed</p>}

                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        No
                    </Button>
                    <Button onClick={() => {
                        if (showOrganizationLiveFeed) {
                            setShowOrganizationLiveFeed(false)
                            socket.close()
                        }
                        else {
                            setShowOrganizationLiveFeed(true)
                            refresh()
                        }
                        closeDialog()
                    }} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}